export enum ActionType {
  API_CURRENCY_DATE_FORMAT = "API_CURRENCY_DATE_FORMAT",
  RESET_REDUX_STATE = "RESET_REDUX_STATE",
}

export interface IDateFormat {
  type: ActionType.API_CURRENCY_DATE_FORMAT;
  payload: any;
}
export interface IResetReduxState {
  type: ActionType.RESET_REDUX_STATE;
}
export type Action = IDateFormat | IResetReduxState;
